import { TimestampStateObject } from '../../types/contexts/globalContext';
import { UserDetails } from '../../types/contexts/userContext';


export function getIsLoggedIn(): boolean {
  // Check localStorage for userDetails. If there is none, initialise it ourselves and setLocalStorage. If there is some, return this for the inital state.
  const savedUserDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  if (Object.keys(savedUserDetails).length === 0) return false;
  return (savedUserDetails as UserDetails).user_id > 0
}
export function getIsAdmin(): boolean {
  // Check localStorage for userDetails. If there is none, initialise it ourselves and setLocalStorage. If there is some, return this for the inital state.
  const savedUserDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  if (Object.keys(savedUserDetails).length === 0) return false;
  return savedUserDetails.isadmin;
}

export const statusCodeMessageObject: Record<number, string> = {
  401: "Error: Unauthorized access. Log in has expired. Please try logging in again."
}

export function getInitialTimestampState() {
  const defaultTimestampState: TimestampStateObject = {
    fetch: {
      newTeeTypes: "",
      vendors: "",
      costslog: "",
      matchingcolors: "",
      materials: "",
      uniqueColors: "",
    },
    pageLoad: {
      wholeSite: "",
      search: "",
      idealMeasures:"",
    }
  }
  const savedTimestampLocalStorage = JSON.parse(localStorage.getItem('timestamps') || '{}');

  if (Object.keys(savedTimestampLocalStorage).length === 0) {
    localStorage.setItem("timestamps", JSON.stringify(defaultTimestampState))
    return defaultTimestampState;
  }
  return (savedTimestampLocalStorage as TimestampStateObject)
}